import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import 'bootstrap/dist/css/bootstrap.css';

class Progress extends Component {
    constructor(props) {
        super(props);
        this.interval = null;
        this.state = {
            now: -1
        }
    }

    componentDidMount() {
        this.props.log('Progress.js/componentDidMount');
        this.interval = setInterval(this.checkTime,250);
    }

    componentWillUnmount = () => {
        this.props.log('Progress.js/componentDidUnmount');
        if (this.interval != null) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    checkTime = () => {
        this.props.info('Progress.js/checkTime');
        const endTime = this.props.autoReloadTime != null ? this.props.autoReloadTime : 0;
        const startTime = this.props.autoReloadTime != null && this.props.autoReload != null ? endTime - (this.props.autoReload * 1000) : 1;
        const current = new Date().getTime();
        const percentage =  this.props.autoReloadTime != null && this.props.autoReload != null ? (current - startTime) / (this.props.autoReload * 1000) : -1;
        this.setState({
            now: percentage * 100
        })
    }

    render() {
        this.props.info('Progress.js/render');
        return (
            <>
                <Row className='mt-1'>
                    <Col>
                        {this.state.now >= 0 && <ProgressBar style={{height: "3px"}} variant="primary" now={this.state.now} />}
                    </Col>
                </Row>
            </>
        )
    }
}

export default Progress;
